import { render } from "./buttonStyle.vue?vue&type=template&id=063b9fb0&scoped=true"
import script from "./buttonStyle.vue?vue&type=script&lang=js"
export * from "./buttonStyle.vue?vue&type=script&lang=js"

import "./buttonStyle.vue?vue&type=style&index=0&id=063b9fb0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063b9fb0"]])

export default __exports__